import React from "react";
import { ServiceHero, SectionTitle, FeatureCard } from "@/components/Bits";
import { RequestForm } from "@/components/RequestForm";
import { useLang } from "@/context/LanguageContext";
import { Wallet, Users, ClipboardCheck, Wrench, FileBarChart, Globe2, Home, Hammer } from "lucide-react";

const ICONS = [Wallet, Users, ClipboardCheck, Hammer, Wrench, Globe2, FileBarChart, Home];

export default function Gestion() {
  const { t } = useLang();
  const services = t("svc.ges.services").map((s, i) => ({ icon: ICONS[i], title: s.t, desc: s.d }));
  return (
    <div className="bg-ivory">
      <ServiceHero eyebrow={t("svc.ges.eyebrow")} title={t("svc.ges.title")} subtitle={t("svc.ges.subtitle")}
        image="https://images.unsplash.com/photo-1724582586458-a51791349977?w=1920&q=85" />
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20">
        <SectionTitle eyebrow={t("svc.ges.sEyebrow")} title={t("svc.ges.sTitle")} className="mb-12" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => <FeatureCard key={s.title} {...s} />)}
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 pb-24">
        <SectionTitle center title={t("svc.ges.formTitle")} subtitle={t("svc.ges.formSub")} className="mb-8" />
        <RequestForm type="gestion" testid="gestion-form" submitLabel={t("svc.ges.submit")}
          fields={[
            { name: "subject", label: t("svc.ges.fType"), placeholder: t("svc.ges.fTypePh") },
            { name: "location", label: t("svc.ges.fLoc"), placeholder: t("svc.ges.fLocPh") },
            { name: "category", label: t("svc.ges.fCount"), placeholder: t("svc.ges.fCountPh") },
          ]} />
      </section>
    </div>
  );
}
